/**
 *
 * @param {String} imageUrl : image url which contains '/'
 * @returns {String} of image name.
 */
export function parseImageName(image) {
  const index = [];
  if (image?.includes('/')) {
    image?.split('').forEach((char, idx) => {
      if (char === '/') {
        index.push(idx);
      }
    });
    return image.substring(index[index.length - 1] + 1, image.length);
  }
  return image;
}

/**
 *
 * @param {Object} tag
 * @param {String} imageName
 * @returns {Boolean} returns true if image id in influencer_tags matches image id of current product.
 */
export const isImageNameEqual = (tag, imageName) => {
  const tagImageName = tag.imageId;
  const tagImageNameWithoutExtension = tagImageName && tagImageName.split('.')[0];
  const imageNameWithoutExtension = imageName.split('.')[0];

  return tagImageNameWithoutExtension === imageNameWithoutExtension;
};

/**
 *
 * @param {Array} influencerTags
 * @param {Number} index
 * @param {String} image
 * @param {Object} altImage
 * @returns {Array} array of influencer handles.
 */
export default function getInfluencerHandles(
  influencerTags,
  index,
  image,
) {
  let handles = [];
  if (!influencerTags || !influencerTags.length || !image) return handles;
  const imageName = parseImageName(image);

  // if main image has influencer handles. add check of unique handles.
  influencerTags
    .filter((tag) => isImageNameEqual(tag, imageName))
    .forEach((tag) => handles.push(...tag.handle.split(';')));
  handles = [...new Set(handles)];
  if (handles.length > 3) {
    return handles.slice(0, 3);
  }
  return handles;
}
